export const getDeviceNameOptions = (
  value: string | undefined,
  fallbackOptions: string[]
): string[] => {
  if (!value?.trim()) {
    return fallbackOptions;
  }

  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) {
      const fromJson = parsed
        .map((option) => String(option).trim())
        .filter(Boolean);

      if (fromJson.length > 0) {
        return fromJson;
      }
    }
  } catch {
    // Ignore and fallback to delimiter parsing.
  }

  const fromString = value
    .split(/[\n,;]+/)
    .map((option) => option.trim())
    .filter(Boolean);

  return fromString.length > 0 ? fromString : fallbackOptions;
};
